import { Injectable } from '@angular/core';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FormControlUtilsService { 

  /**
	 * Method to check if all fields have value when create record
	 * @param lstFields 	List all fields that need to check
	 * @param obj 			object to check value
	 * @return true	, if all fields in the object has value
	 */
	isValidRequiredFields(lstFields:string[], obj:any){ 
		let isValid:boolean = true;

		if(!lstFields.length) return isValid; 

		lstFields.forEach(field => { 
			let fieldVal = get(obj, field);
			if(fieldVal == undefined || (fieldVal !== undefined && !fieldVal)){  
				isValid = false;
			}
		}); 

		return isValid;
	} 
}
